export default __webpack_public_path__ + "static/media/bg-confirm-button.ef7931d9.svg";